import { Routes, Route, useLocation } from 'react-router-dom'; // Import useLocation from react-router-dom
import Navbar from './Navbar'; // Import Navbar
import Login from './Login';
import Transfer from './Transfer';
import ApiDetails from './ApiDetails';
import PrivateRoute from './PrivateRoute';
import TransactionList from './TransactionList';

const App = () => {
  const location = useLocation(); // Get the current route

  return (
    <div>
      {/* Only render Navbar if the current route is not the login page */}
      {location.pathname !== "/" && <Navbar />}
      
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/list"
          element={
            <PrivateRoute>
              <TransactionList />
            </PrivateRoute>
          }
        />
        <Route
          path="/transfer"
          element={
            <PrivateRoute>
              <Transfer />
            </PrivateRoute>
          }
        />
        <Route
          path="/keys"
          element={
            <PrivateRoute>
              <ApiDetails />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
